import Phones from "google-libphonenumber";
import Settings from "./settings.service";
import Storage from "./storage.service";
var FieldValidity = {};
let phoneUtil = Phones.PhoneNumberUtil.getInstance();
FieldValidity.checkFieldValidity = (value, validations, dependency = {}) => {
    if (validations.required && value.trim() === "") return false;
    if (validations.requiredObject && value.trim() === "") return { "valid": false, "type": "required" };;
    if (validations.minLength && ((value + "").trim().length < validations.minLength))
        return { "valid": false, "type": "length" };
    if (validations.maxLengthObj && ((value + "").trim().length > validations.maxLengthObj))
        return { "valid": false, "type": "maxLength" };
    if (validations.maxLengthObj && ((value + "").trim().length < validations.maxLengthObj + 1))
        return { "valid": true, "type": "maxLength" };
    if (validations.maxLength && ((value + "").trim().length > validations.maxLength))
        return false;
    if (validations.minValue && ((value + "").trim() < validations.minValue))
        return { "valid": false, "type": "minLength" };
    if (validations.maxValue && ((value + "").trim() > validations.maxValue))
        return { "valid": false, "type": "maxLength" };
    if (validations.maxValue && ((value + "").trim() < validations.maxValue + 1))
        return { "valid": true, "type": "maxLength" };
    if (validations.minValueZero === 0 && ((value + "").trim() <= 0)) {
        return { "valid": false, "type": "minLength" };
    }
    if (validations.numberOnly && !(/^\d+$/.test(value)) && value.trim() !== "")
        return false;
    if (validations.stringOnly) {
        let valid = /^[a-zA-Z ]*$/.test(value)
        return { "valid": valid, "type": "text" };
    }
    if (validations.topupNumber) {
        let business = Storage.get("business", true);
        let numberRegex = "";
        let valid = true;
        if (business) {
            business = JSON.parse(business);
            numberRegex = business?.phone_number_regex;
            if (numberRegex) {
                const reg = new RegExp(numberRegex);
                valid = reg.test(value);
            }
        }
        return { "valid": valid, "type": "number" };
    }

    if (validations.minLengthBool && ((value + "").trim().length < validations.minLengthBool)) {
        return false;
    };

    if (validations.contactNumber) {
        let contactvalue = value.replace(0, "")
        let testCondition = Settings.formats.phonenumberContact.test(contactvalue)
        if (contactvalue.length > 6 && testCondition) {
            if (dependency && dependency?.value) {
                let number = phoneUtil.parse(contactvalue, dependency.value);
                let valid = phoneUtil.isValidNumber(number);
                return valid;
            } else {
                let valid = Settings.formats.phonenumber.test(contactvalue);
                return valid;
            }
        }
        else {
            return false;
        }
    }
    return true;
}
FieldValidity.inputDigits = (event, limit = 14) => {
    const re = /^[0-9]{0,10}$/
    return event.target.value === '' || (event.target.value.length <= limit && re.test(event.target.value))
}

export default FieldValidity;